export enum OrganizationUserInvitationMethodTypes {
    CREATE = "CREATE",
    INVITE = "INVITE"
}